import { useState, useEffect } from 'react';
import api from '../../utils/api';

function getStatus(hotel) {
  if (hotel.status === 'active' || hotel.isActive === true && !hotel.trialEndsAt) {
    return { label: '🟢 Aktif', color: '#16a34a' };
  }
  if (hotel.trialEndsAt) {
    const now = new Date();
    const trialEnd = new Date(hotel.trialEndsAt);
    if (trialEnd > now) {
      const daysLeft = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));
      return { label: `🟡 Deneme (${daysLeft} gün kaldı)`, color: '#ca8a04' };
    } else {
      return { label: '🔴 Süresi Doldu', color: '#dc2626' };
    }
  }
  if (hotel.status === 'active') {
    return { label: '🟢 Aktif', color: '#16a34a' };
  }
  return { label: '⚪ Bilinmiyor', color: '#64748b' };
}

export default function SuperAdminSignups() {
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/superadmin/signups')
      .then(data => { setHotels(data.hotels || []); setLoading(false); })
      .catch(err => { setError(err.error || 'Veri alınamadı'); setLoading(false); });
  }, []);

  const now = new Date();
  const oneWeekAgo = new Date(now - 7 * 24 * 60 * 60 * 1000);

  const filtered = hotels.filter(h =>
    h.name?.toLowerCase().includes(search.toLowerCase()) ||
    h.email?.toLowerCase().includes(search.toLowerCase())
  );

  const totalCount = hotels.length;
  const activeTrialCount = hotels.filter(h => h.trialEndsAt && new Date(h.trialEndsAt) > now).length;
  const thisWeekCount = hotels.filter(h => new Date(h.createdAt) > oneWeekAgo).length;

  if (loading) return (
    <div style={{ padding: 40, color: '#64748b', textAlign: 'center' }}>Yükleniyor...</div>
  );
  if (error) return (
    <div style={{ padding: 40, color: '#dc2626' }}>Hata: {error}</div>
  );

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Kayıtlar</h1>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>Reseptio'ya kayıt olan tüm oteller</p>

      {/* Özet kartlar */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 28, flexWrap: 'wrap' }}>
        {[
          { label: 'Toplam Kayıt', value: totalCount, color: '#6366f1' },
          { label: 'Aktif Deneme', value: activeTrialCount, color: '#ca8a04' },
          { label: 'Bu Hafta Yeni', value: thisWeekCount, color: '#16a34a' },
        ].map(({ label, value, color }) => (
          <div key={label} style={{
            background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12,
            padding: '18px 28px', minWidth: 140, boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
          }}>
            <div style={{ fontSize: 28, fontWeight: 800, color }}>{value}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Arama */}
      <div style={{ marginBottom: 20 }}>
        <input
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Otel adı veya e-posta ile ara..."
          style={{
            padding: '10px 16px', borderRadius: 8, border: '1.5px solid #e2e8f0',
            fontSize: 14, width: 320, outline: 'none',
          }}
        />
      </div>

      {/* Tablo */}
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
              {['Otel Adı', 'E-posta', 'Kayıt Tarihi', 'Deneme Bitiş', 'Durum'].map(h => (
                <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#475569', fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>
                  {search ? 'Arama sonucu bulunamadı.' : 'Henüz kayıt yok.'}
                </td>
              </tr>
            ) : filtered.map((hotel, i) => {
              const status = getStatus(hotel);
              return (
                <tr key={hotel.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ padding: '12px 16px', fontWeight: 600, color: '#1e293b' }}>{hotel.name}</td>
                  <td style={{ padding: '12px 16px', color: '#475569' }}>{hotel.email || '—'}</td>
                  <td style={{ padding: '12px 16px', color: '#64748b' }}>
                    {new Date(hotel.createdAt).toLocaleString('tr-TR')}
                  </td>
                  <td style={{ padding: '12px 16px', color: '#64748b' }}>
                    {hotel.trialEndsAt ? new Date(hotel.trialEndsAt).toLocaleDateString('tr-TR') : '—'}
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      fontSize: 12, fontWeight: 600, color: status.color,
                      background: status.color + '18', padding: '3px 10px', borderRadius: 20,
                    }}>
                      {status.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p style={{ marginTop: 12, fontSize: 12, color: '#94a3b8' }}>{filtered.length} kayıt gösteriliyor</p>
    </div>
  );
}
